import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ProductsList from '@app/components/manage-products/list';

const ProductsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('products.view')}</PageTitle>
      <ProductsList />
    </>
  );
};

export default ProductsPage;
